import {Injectable} from "@angular/core";
import {ReplaySubject, Subject} from "rxjs";
import {Observable} from "rxjs/internal/Observable";
import {DahSignAction} from "./dahsign.type";

@Injectable({
    providedIn: 'root'
})

export class DahSignService {
    isLoaded: boolean;
    isLoading: boolean;

    loadDahSignModule$: Subject<DahSignAction | void> = new ReplaySubject<DahSignAction | void>();

    run$: Subject<DahSignAction> = new Subject<DahSignAction>();
    runSubscriber$: Subject<any> = new Subject<any>();

    run(action: DahSignAction): Observable<any> {
        this.runSubscriber$ = new Subject<any>();
        if (this.isLoaded) {
            this.run$.next(action);
            action.libInit && action.libInit();
        } else {
            this.loadDahSignModule$.next(action);
        }
        return this.runSubscriber$;
    }
}
